module.exports = __webpack_public_path__ + "logo-topbar@2x-47cfca95e3be6af4ce6260edc528ca7e.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/img/logo-topbar@2x.png
// module id = 364
// module chunks = 0